import React from 'react'
import styled from 'styled-components'
import { translate as translateMain } from 'loankeeper-common/helpers'
import { LKButton as LKBaseButton, LKIcon } from 'loankeeper-common/components'

import LKModal, { LKModalContainer } from 'shared/LKModal'
import ServerTimeTicker from 'shared/ServerTimeTicker'
import { CHANGE_DATE_TIME_MODAL } from './constants'

const translate = (name) => translateMain(`frm_web_messages-${name}`)

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .change-date-time-description {
    line-height: 25px;
    margin-bottom: 10px;

    .lk-icon {
      margin-right: 6px;
    }
  }

  .server-time {
    font-size: 0.95rem;
  }
`

const ChangeDateTimeModal = ({ modalInstanceName, message, closeModal, params }) => (
  <LKModal
    name={modalInstanceName}
    heading={translateMain('LKMESSAGE-MSG_ERROR')}
    dataAttributes={params && params.code && { 'data-code': params.code }}
    size="xs"
    footer={
      <LKModal.Footer>
        <LKBaseButton.Okay onClick={closeModal} />
      </LKModal.Footer>
    }
  >
    <Wrapper>
      <div className="change-date-time-description">
        <LKIcon alias="circular_clock" size={25} />
        {translate('SET_DATETIME')}
      </div>
      <span className="server-time">
        <ServerTimeTicker currentDate={message} />
      </span>
    </Wrapper>
  </LKModal>
)

export default LKModalContainer(CHANGE_DATE_TIME_MODAL)(ChangeDateTimeModal)
